export const CAR_SUBMIT_FORM = 'car_submit_form'
export const CLEAR_CAR_FORM = 'clear_car_form'